// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * Returns the earliest local calendar date a patient may book.
 * Today and the entire following calendar day are unavailable.
 */
export function getEarliestPatientBookableStart(now = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2);
}

export function isPatientBookableStart(start: string | undefined, now = new Date()): boolean {
  const startTime = start ? new Date(start).getTime() : Number.NaN;
  return Number.isFinite(startTime) && startTime >= getEarliestPatientBookableStart(now).getTime();
}
